// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdPolicyApi, AdRegApi, AdPolicySgApi, AdRegSgApi } from "_Route/Api";


const AdDevGuideDt = ({type}) => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();

  const curType = params.id === 'add' ? '등록' : '수정';
  const curScore = params.id === 'add' ? 200 : 300;
  const useGroup = ['미사용', '사용'];
  const curGuideSgApi = type === "policy" ? AdPolicySgApi : AdRegSgApi;
  const curGuideApi = type === "policy" ? AdPolicyApi : AdRegApi;
  const curTitle = type === "policy" ? 'Security Policy' : 'Development Regulation';

  const sessionID = localStorage.getItem('memSessionID')
  const userName = useSelector(state => state.authorityAcc.name);
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);

  const [useIdx, setUseIdx] = useState(1);
  const [info, setInfo] = useState({
    devguide_title: '',
    devguide_content: '',
  })
  const { devguide_title, devguide_content } = info;
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
  
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  // GET Current Guide List
  useEffect(() => {
    if (curType === '수정') {
      axios.get(curGuideSgApi, {
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        params: {
          devguide_uuid: params.id
        }
      })
      .then(res => {
        const curGuide = res.data.result[0]
        if(curGuide === undefined && params.id !== 'add') {
          navigate('/404');
        }

        setUseIdx(curGuide.devguide_use);
        setInfo({devguide_title: curGuide.devguide_title, devguide_content: curGuide.devguide_content})
      })
      .catch(err => {
        console.error(err, `GET ${curTitle} Data Error...`);
      })
    }
  }, [])

  // Guide Axios 
  const postGuide = () => {
    if(devguide_title === '') { alert("제목을 입력해주세요.") }
    else if (devguide_content === '') { alert("내용을 입력해주세요.") }
    else {
      axios({
        url: curGuideApi,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        data: {
          devguide_use: useIdx,
          devguide_title: devguide_title,
          devguide_content: devguide_content,
          devguide_create_user: userName,
          approve_spec_status: 0,
          approve_ap_status: 0,
        }
      })
      .then(res => {
        alert(`${curTitle} 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
        navigate(`/admin/dev-guide/${type}/list`)
      })
      .catch(err => {
        console.error(err, `${curTitle} POST Error..`)
        const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
      })
    }
  }

  const updateGuide = () => {
    if(devguide_title === '') { alert("제목을 입력해주세요.") }
    else if (devguide_content === '') { alert("내용을 입력해주세요.") }
    else {
      axios({
        url: curGuideApi,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        data: {
          devguide_uuid: params.id,
          devguide_use: useIdx,
          devguide_title: devguide_title,
          devguide_content: devguide_content,
          devguide_create_user: userName,
          devguide_last_modify_user: userName,
          approve_spec_status: 0,
          approve_ap_status: 0,
        }
      })
      .then(res => {
        alert(`${curTitle} 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
        navigate(`/admin/dev-guide/${type}/list`)
      })
      .catch(err => {
        console.error(err, `${curTitle} PUT Error..`)
        const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
      })
    }
  }

  const deleteGuide = () => {
    axios({
      url: curGuideApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        devguide_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`${curTitle} 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate(`/admin/dev-guide/${type}/list`)
    })
    .catch(err => {
      console.error(err, `${curTitle} DELETE Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>{curTitle} {curType}</h2>
        <p>Home / Dev Guide / {curTitle} {curType}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>{curTitle} 글 수정</legend>

          {/* 사용여부 [devguide_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" id={`devguide_use_${i}`} onChange={() => setUseIdx(i)} checked={useIdx === i}/>
                  <label htmlFor={`devguide_use_${i}`}></label>

                  <label htmlFor={`devguide_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 제목 [devguide_title] */}
          <div className="fieldGroup row">
            <label>제목<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" name="devguide_title" value={devguide_title} onChange={(e) => onChange(e)} placeholder="제목을 입력해주세요." />
            </div>
          </div>

          {/* 내용 [devguide_content] */}
          <div className="fieldGroup row">
            <label>내용<span className="redTxt">*</span></label>

            <div className="field full">
              <textarea type="text" style={{height: '250px'}} className="textarea md round" name="devguide_content" value={devguide_content} onChange={(e) => onChange(e)} placeholder="내용을 입력해주세요." />
            </div>
          </div>

          {/* 작성/수정자 */}
          <div className="fieldGroup row">
            <label>{curType}자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 작성/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={curType === '수정' ? updateGuide : postGuide}>{curType}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate(`/admin/dev-guide/${type}/list`)}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 게시물을 삭제하시겠습니까?`)) deleteGuide() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdDevGuideDt;